  <template>
  <div>
    <form>
      <!-- ///responsável -->
      <div class="">
      
      <div class="row">

          <!-- <div
          class="col-md-3"
           v-if="data.id"
        >
          <form-group-image
            :url="url+'formpayment/icon/'+data.id"
            :value="data.ImageURL"
            img-type="square"
          />
        </div> -->
        
        <div class="col-md-6">
          <fg-input
            class="clean"
            type="text"
            label="Titulo"
            placeholder="Titulo"
            v-model="data.name"
            v-bind:readonly="readonly"
          />
        </div>

        <div class="col-md-6">
          <fg-input
            class="clean"
            type="text"
            label="SubTitulo"
            placeholder="SubTitulo"
            v-model="data.subTitle"
            v-bind:readonly="readonly"
          />
        </div>
          <div class="col-md-6">

        <fg-select
              :options="activeList"
              v-model="data.isActive"
              :selected="data.isActive"
              label="Promoção Ativa"
            />
          </div>
      </div>
      </div>
    </form>

 
  </div>
</template>
<script>
  import {mapActions, mapState, mapGetters} from "vuex";
  import moment from 'moment';
  import formGroupImage from 'src/components/UIComponents/Inputs/formGroupImage.vue';
  import {NAMES} from "../../../config"


  export default {
    name: "promotion-form",
     components: {
      formGroupImage
    },

    props: {
      data: {
        type: Object,
      },
      readonly: {
        type: Boolean,
        default: false
      },
      event: {
        type: String,
        default: ''
      },
        url: {
        type: String,
        default: NAMES.fullUrl
      }
    },

    computed: {
      ...mapState({
        
      })
    },

    methods: {
      ...mapActions([""]),
      ...mapGetters({
        sidebarFlag: 'sidebarFlag'
      }),
      unlock() {
        if (this.sidebarFlag() === 'ADMIN') {
          this.localReadonly = !this.localReadonly
        } else {
          this.localReadonly = true;
        }
      },
      
      formatDate(date){
        return moment.utc(date).utcOffset(-180).format('D/M/YYYY H:mm:ss')
      }
    },

    created() {
        this.$on("execute", () => {
        this.$parent.$emit(this.event, this.data);
      });

    },
    data() {
      return {
        localReadonly: false,
         activeList:[
          {
            value: true,
            name: "Ativo"
          },
          {
            value: false,
            name: "Não Ativo"
          }
        ],
      };
    },

  };
</script>
<style scoped lang="scss">
  label.stronger {
    font-weight: bold;
    color: black;
  }

  .stronger {
    font-weight: bold;
    color: black;
    margin: 15px 0 0 0 !important;
  }

  p.subject {
    color: #9c9c9c;
  }

</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/PromotionForm.vue